import { render } from "./EnrolleeKillAccountOnboardComponent.vue?vue&type=template&id=0e7840db&scoped=true"
import script from "./EnrolleeKillAccountOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeKillAccountOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeKillAccountOnboardComponent.vue?vue&type=style&index=0&id=0e7840db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7840db"]])

export default __exports__